import * as React from 'react';
const SvgCalendar = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="currentColor"
      d="M7.5 9.792a1.042 1.042 0 1 1-2.083 0 1.042 1.042 0 0 1 2.083 0M10 10.833a1.042 1.042 0 1 0 0-2.083 1.042 1.042 0 0 0 0 2.083M7.5 13.542a1.042 1.042 0 1 1-2.083 0 1.042 1.042 0 0 1 2.083 0M10 14.583a1.042 1.042 0 1 0 0-2.083 1.042 1.042 0 0 0 0 2.083M14.583 9.792a1.042 1.042 0 1 1-2.083 0 1.042 1.042 0 0 1 2.083 0"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2.375 5.208a2.834 2.834 0 0 1 2.833-2.833h9.584a2.834 2.834 0 0 1 2.833 2.833v9.584a2.834 2.834 0 0 1-2.833 2.833H5.208a2.834 2.834 0 0 1-2.833-2.833zm2.833-1.333c-.736 0-1.333.597-1.333 1.333v.5h12.25v-.5c0-.736-.597-1.333-1.333-1.333zM3.875 14.792V7.209h12.25v7.583c0 .736-.597 1.333-1.333 1.333H5.208a1.334 1.334 0 0 1-1.333-1.333"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCalendar;
